import {CONSTANTS} from "./meta_data";
import {arrayIndexByKeyValue} from "../global/arrayHelper";

export class ZIndexEntry {
    public id;
    public floating;

    constructor(id:string, floating:number) {
        this.id=id;
        this.floating = floating;
    }
}

export class Z_OrderTable {
    public values:Array<Array<ZIndexEntry>>;


    constructor() {
        this.values = [];
    }

    public clone() {
        const out = new Z_OrderTable();
        out.values = this.values.map(firstlevel=>firstlevel.map(e=>new ZIndexEntry(e.id, e.floating)));
        return out;
    }

    public getZIndex(id:string) {
        let i, len;
        for (i = 0, len = this.values.length; i < len; i++) {
            if (typeof(this.values[i]) !== "undefined") {
                if (arrayIndexByKeyValue(this.values[i], "id", id) > -1) {
                    return i;
                }
            }
        }
        return -1;
    }

    private lowestZIndexThatShouldStayOnTop() {
        let i, lenI;

        for (i = 0, lenI = this.values.length; i < lenI; i++) {
            if(Z_OrderTable.hasFloatTopEntry(this.values[i])) {
                return i;
            }
        }
        return -1;
    }

    private static hasFloatTopEntry(zIndexEntryArray: Array<ZIndexEntry>) {
        let i, len;
        for (i = 0, len = zIndexEntryArray.length; i < len; i++) {
            if (zIndexEntryArray[i].floating === CONSTANTS.FLOAT_TOP) {
                return true;
            }
        }
        return false;
    }

    insertEntryIntoZIndex (id:string, floating = CONSTANTS.FLOAT_FREE, zIndex, mayBeAppendedToEntry = true){
        if (typeof zIndex === "undefined") {
            console.warn("zIndex was undefined in insertEntryIntoZIndex");
            zIndex = 0;
        }
        const objectToInject = new ZIndexEntry(id, floating);
        if (typeof(this.values[zIndex]) === "undefined") {
            this.values[zIndex] = [objectToInject];
            this.fillUpHolesInValues();
        } else {
            if ((floating !== CONSTANTS.FLOAT_TOP && Z_OrderTable.containsFloatTopEntry(this.values[zIndex]) > -1) || ! mayBeAppendedToEntry) {
                this.values.splice(zIndex, 0, [objectToInject]);
            }
            if (arrayIndexByKeyValue(this.values[zIndex], "id", id) === -1) {
                this.values[zIndex].push(objectToInject);
            }
        }
    }

    public insertEntry(id:string, cloneIds:Array<string>, floating = CONSTANTS.FLOAT_FREE) {
        let lowestZindexToStayOnTop;

        const objectToInject = new ZIndexEntry(id, floating);

        const zIndexOfClone = this.getZIndexOfClone(cloneIds);
        if (zIndexOfClone > -1) {
            this.values[zIndexOfClone].push(objectToInject);
            return zIndexOfClone;
        }

        switch(floating) {
            case CONSTANTS.FLOAT_TOP :
                this.values.push([objectToInject]);
                return this.values.length - 1;
            case CONSTANTS.FLOAT_BOTTOM:
                this.values.splice(0, 0, [objectToInject]);
                return 0;
            default:
                lowestZindexToStayOnTop = this.lowestZIndexThatShouldStayOnTop();
                if (lowestZindexToStayOnTop > -1) {       //es gibt ein "FLOAT_TOP" Element
                    this.values.splice(lowestZindexToStayOnTop, 0, [objectToInject]);
                    return lowestZindexToStayOnTop;
                }
                this.values.push([objectToInject]);
                return this.values.length - 1;
        }
    }

    private static containsFloatTopEntry(zIndexEntryToInsertTo: Array<ZIndexEntry>) {
        return arrayIndexByKeyValue(zIndexEntryToInsertTo, "floating", CONSTANTS.FLOAT_TOP);
    }

    private getZIndexOfClone(cloneIds: Array<string>) {
        let i, lenI;
        for (i = 0, lenI = cloneIds.length; i < lenI; i++) {
            const zOrderOfCloneId = this.getZIndex(cloneIds[i]);
            if (zOrderOfCloneId > -1) {
                return zOrderOfCloneId;
            }
        }
        return -1;
    }

    private fillUpHolesInValues () {
        let i, lenI;
        for (i=0, lenI = this.values.length; i < lenI; i++) {
            if (typeof(this.values[i]) === "undefined") {
                this.values[i] = [];
            }
        }
    }

    public deleteEntry(id:string) {

        let i, entryIndex;

        for (i = this.values.length - 1; i > -1; i--) {
            entryIndex = arrayIndexByKeyValue(this.values[i], "id", id);
            if (entryIndex > -1) {
                this.values[i].splice(entryIndex, 1);
                if (this.values[i].length === 0) {
                    this.values.splice(i, 1);
                }
                return;
            }
        }
    }

    public changeZOrder(from:number, to:number) {
        const save = this.values[from];
        this.values.splice(from, 1);
        this.values.splice(to, 0, save);
    }

    setValues(values:Array<Array<ZIndexEntry>>) {
        this.values = values;
    }

    /**
     * Prüft, ob einer der Einträge in this.values null oder undefined ist. Gibt true zurück, wenn das der fall ist.
     * @return {boolean}
     */
    public hasHoles() {
        let i;

        for (i = this.values.length - 1; i > -1; i--) {
            if (typeof(this.values[i]) === "undefined" || this.values[i] === null) {
                return true;
            }
        }
        return false;
    }

    /**
     * Läuft das Array this.values durch und löscht Einträge, die null oder undefined sind. Kein Returnwert!
     */
    public patchHoles() {
        let i;
        for (i = this.values.length - 1; i > -1; i--) {
            if (this.values[i] === null || typeof (this.values[i]) === "undefined") {
                this.values.splice(i, 1);
            }
        }
    }

    public static getZIndexToChangeTo(zIndizes, ownZIndex: number, direction:"up"|"down") {
        if (direction === "up") {
            return Z_OrderTable.getNextBiggerZIndex(zIndizes, ownZIndex);
        } else {
            return Z_OrderTable.getNextSmallerZIndex(zIndizes, ownZIndex);
        }
    }

    private static getNextSmallerZIndex(zIndizes, ownZIndex: number) {
        let i, foundIndex = -1;
        const anzZIndizes = zIndizes.length;
        for (i = 0; i < anzZIndizes; i++) {
            if (zIndizes[i] < ownZIndex) {
                foundIndex = i;
            } else {
                break;
            }
        }
        return foundIndex;
    }

    private static getNextBiggerZIndex(zIndizes, ownZIndex: number) {
        let i, foundIndex = -1;
        for (i = zIndizes.length - 1; i > -1; i--) {
            if (zIndizes[i] > ownZIndex) {
                foundIndex = i;
            } else {
                break;
            }
        }
        return foundIndex;
    }
}
